import React from 'react';

const ListedCompanyResultsContext = React.createContext();

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setLoadingWiresMentioning':
      return { ...state, loadingWiresMentioning: payload };
    case 'setWiresMentioning':
      return { ...state, wiresMentioning: payload };
    case 'setContributors':
      return { ...state, contributors: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  loadingWiresMentioning: null,
  wiresMentioning: [],
};

export default ListedCompanyResultsContext;
export {
  reducer,
  defaultState,
};
